import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { IRole } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class RolesManagementService {
  readonly #http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/roles`;

  getRoles(): Observable<IRole[]> {
    return this.#http.get<IRole[]>(`${this.apiUrl}`);
  }
  getRoleById({
    token,
    roleId,
  }: {
    token: string;
    roleId: string;
  }): Observable<IRole> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.#http.get<IRole>(`${this.apiUrl}/get-role/${roleId}`, {
      headers,
    });
  }
  deleteRole(roleId: string): Observable<string> {
    return this.#http.delete(`${this.apiUrl}/delete-role/${roleId}`, {
      responseType: 'text',
    });
  }

  addRole(role: IRole): Observable<IRole> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, updatedAt, ...rest } = role;
    return this.#http.post<IRole>(`${this.apiUrl}/create-role`, rest);
  }

  updateRole(role: IRole): Observable<IRole> {
    const payload = {
      id: role.id,
      name: role.name,
      permissions: {
        desktop: role.permissions.desktop.map((permission) => ({
          resource: permission.resource,
          actions: permission.actions,
        })),
        mobile: role.permissions.mobile.map((permission) => ({
          resource: permission.resource,
          actions: permission.actions,
        })),
      },
      icon: role.icon,
      description: role.description,
      assignedUsers: role.assignedUsers,
    };
    return this.#http.put<IRole>(
      `${this.apiUrl}/update-role/${role.id}`,
      payload,
    );
  }

  assignRoleToUsers(role: IRole): Observable<IRole> {
    return this.#http.put<IRole>(`${this.apiUrl}/assign-role`, {
      usersId: role.assignedUsers,
      roleToAssign: role.id,
    });
  }
}
